import React from "react";
import ClarkMachineCard from "./clarkMachineCard";

const CompactCounterbalanceTrucks = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Čelní vozíky s pohonem na LPG a plnopryžovými (cushion) pneumatikami</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-c15c-20sc.webp"
          imgAlt="Obrázek čelního vozíku s pohonem na LPG a plnopryžovými (cushion) pneumatikami CLARK c15c-20sc"
          title="CLARK série C15C/18C/20sC"
          loadCapacity="1 500 - 2 000 kg"
          drive="LPG"
          liftHeight="2 265 - 7 075 mm"
          maxSpeed="až 16 km/h"
          link="https://clarkmheu-com.translate.goog/en/compact-lpg-forklifts/c15-18-20sc?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-s20-32c.webp"
          imgAlt="Obrázek čelního vozíku s pohonem na LPG a plnopryžovými (cushion) pneumatikami CLARK s20-32c"
          title="CLARK série S20C/25C/30C/32C"
          loadCapacity="2 000 - 3 200 kg"
          drive="LPG"
          liftHeight="2 120 - 7 935 mm"
          maxSpeed="až 18.6 km/h"
          link="https://clarkmheu-com.translate.goog/en/compact-lpg-forklifts/s20-25-30-32c?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-CGC40-70.webp"
          imgAlt="Obrázek čelního vozíku s pohonem na LPG a plnopryžovými (cushion) pneumatikami CLARK CGC40-70"
          title="CLARK série CGC40/50/55/60/70"
          loadCapacity="4 000 - 7 000 kg"
          drive="LPG"
          liftHeight="2 545 - 6 985 mm"
          maxSpeed="až 16.6 km/h"
          link="https://clarkmheu-com.translate.goog/en/compact-lpg-forklifts/cgc40-50-55-60-70?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>
    </div>
  );
};
export default CompactCounterbalanceTrucks;
